import { render } from "./DesignPipeline.vue?vue&type=template&id=770e4a01&scoped=true"
import script from "./DesignPipeline.vue?vue&type=script&lang=js"
export * from "./DesignPipeline.vue?vue&type=script&lang=js"

import "./DesignPipeline.vue?vue&type=style&index=0&id=770e4a01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770e4a01"]])

export default __exports__